const de = {
  uid: 'UID',
  entitlements: 'Berechtigungen',
  role: 'Rolle',
  actions: 'Aktionen',
  meta: 'Metaobjekt',
  roles: 'Rollen',
  communities: 'Communities',
  alerts: {
    loadUsersError: 'Nutzer konnten nicht geladen werden!',
    loadUserError: 'Nutzer konnte nicht geladen werden!',
    loadUserNotFoundError: 'Nutzer konnte nicht gefunden werden!'
  }
};

export default de;
export type ShibUserListTranslation = typeof de;
